import { t } from "i18next";
import ReactApexChart from "react-apexcharts";

const ApexChart = ({ data, chartHeight, type }) => {

    const pieData = {
        series: [data.unattempted, data.correct, data.incorrect],
        options: {
            chart: {
                type: 'donut',
            },
            // #1D63E7(blue)#A9A9A9(dark grey) #D3D3D3(light grey)
            // '#9da39d' (Try grey learnerinterface)
            labels: [t("unattempted"), t("correct"), t("incorrect")],
            colors: ['#dbdbdb', '#23eb23', '#ff6961'], // colors for unattempted, correct, incorrect
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + t("questions");
                    }
                }
            },
            responsive: [{
                breakpoint: 450,
                options: {
                    chart: {
                        // width: 500
                    },
                    legend: {
                        show: false,
                        // position: 'bottom'
                    }
                }
            }],
            legend: {
                // position: 'bottom',
                show: false,
                labels: {
                    colors: ['#dbdbdb', '#23eb23', '#ff6961'],
                    useSeriesColors: false
                }
            }
        }
    };
    return (
        <div>
            <ReactApexChart options={pieData.options} series={pieData.series} type={type ?? "donut"} height={chartHeight ?? 350} />

        </div>
    );
}

export default ApexChart;
